module.exports = __webpack_public_path__ + "media/newstyle/images/norton-9e3ed53543e36db978800fb12bc049a1.svg";